import { editGatewayAndPrice, getListOfGatewayAndPrice } from "../types/gateway_and_price_list_types";

export const getListOfGatewayAndPriceRequest = (payload, cb) => ({
  type: getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_REQUEST,
  payload,
  cb,
});
export const getListOfGatewayAndPriceSuccess = (payload) => ({
  type: getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_SUCCESS,
  payload,
});
export const getListOfGatewayAndPriceError = (payload) => ({
  type: getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_ERROR,
  payload,
});

export const editGatewayAndPriceRequest = (payload, cb) => ({
  type: editGatewayAndPrice.EDIT_GATEWAY_AND_PRICE_REQUEST,
  payload,
  cb,
});
export const editGatewayAndPriceSuccess = (payload) => ({
  type: editGatewayAndPrice.EDIT_GATEWAY_AND_PRICE_SUCCESS,
  payload,
});
export const editGatewayAndPriceError = (payload) => ({
  type: editGatewayAndPrice.EDIT_GATEWAY_AND_PRICE_ERROR,
  payload,
});
